import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoWaipuIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	preserveAspectRatio: "xMidYMid meet",
	viewBox: "0 0 58 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		x1: "49.976%",
		y1: ".05%",
		x2: "49.976%",
		y2: "99.609%",
		id: "waipu-icon-grad-purple",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#A0509A",
			offset: "0%"
		}), /* @__PURE__ */ _jsx("stop", {
			stopColor: "#2A91FF",
			offset: "100%"
		})]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		x1: "49.888%",
		y1: ".05%",
		x2: "49.888%",
		y2: "100.069%",
		id: "waipu-icon-grad-green",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#009652",
			offset: "0%"
		}), /* @__PURE__ */ _jsx("stop", {
			stopColor: "#0FF",
			offset: "100%"
		})]
	})] }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-162, 0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M197.818 4.94c-1.235-2.133-3.147-3.596-5.367-4.329-.062 0-.062 0-.124-.06h-.062a9.716 9.716 0 0 0-2.964-.49c-1.668 0-3.336.428-4.88 1.284l-17.047 9.72c-1.73.978-3.027 2.384-3.83 3.974v.06c0 .062-.062.062-.062.123a9.91 9.91 0 0 0-.988 4.28v19.745c0 1.651.432 3.302 1.297 4.83 1.236 2.14 3.15 3.607 5.374 4.34.062 0 .062 0 .123.062h.062c.927.305 1.977.489 2.965.489 1.668 0 3.335-.428 4.88-1.284l6.306-3.596c1.236 2.134 3.148 3.597 5.367 4.33.062 0 .062 0 .124.06h.062c.926.306 1.976.49 2.964.49 1.668 0 3.336-.428 4.88-1.284l17.047-9.72c1.73-.978 3.027-2.385 3.83-3.974 0-.061 0-.122.062-.183a9.91 9.91 0 0 0 .988-4.28V9.781c0-1.65-.432-3.3-1.297-4.83-1.235-2.139-3.15-3.606-5.374-4.34-.062 0-.062 0-.123-.06h-.062a9.716 9.716 0 0 0-2.965-.49c-1.668 0-3.335.428-4.88 1.284l-6.306 3.596z",
				fill: "#FFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.133 33.807a9.91 9.91 0 0 0 .989-4.28V9.781c0-1.65-.433-3.3-1.298-4.83-1.235-2.139-3.15-3.606-5.373-4.34-.062 0-.062 0-.124-.06h-.062a9.716 9.716 0 0 0-2.964-.49c-1.668 0-3.336.428-4.88 1.284l-17.047 9.72c-1.73.978-3.027 2.384-3.83 3.974v.06c0 .062-.062.062-.062.123a9.91 9.91 0 0 0-.988 4.28v19.745c0 1.651.432 3.302 1.297 4.83 1.236 2.14 3.15 3.607 5.374 4.34.062 0 .062 0 .123.062h.062c.927.305 1.977.489 2.965.489 1.668 0 3.335-.428 4.88-1.284l17.047-9.72c1.73-.978 3.027-2.385 3.83-3.974 0-.061.061-.122.061-.183z",
				fill: "url(#waipu-icon-grad-purple)",
				style: { mixBlendMode: "multiply" },
				transform: "translate(162)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.825 29.527V9.781c0-1.65-.432-3.3-1.297-4.83-1.235-2.139-3.15-3.606-5.374-4.34-.062 0-.062 0-.123-.06-.989-.306-2.039-.49-3.027-.49-1.668 0-3.335.428-4.88 1.284l-17.047 9.72c-1.73.978-3.026 2.384-3.83 3.974 0 .122-.061.122-.061.183a9.91 9.91 0 0 0-.988 4.28v19.745c0 1.651.432 3.302 1.297 4.83 1.235 2.14 3.15 3.607 5.373 4.34.062 0 .062 0 .124.062.988.305 2.038.489 3.026.489 1.668 0 3.336-.428 4.88-1.284l17.047-9.72c1.73-.978 3.027-2.385 3.83-3.974 0-.061 0-.122.062-.183a9.91 9.91 0 0 0 .988-4.28z",
				fill: "url(#waipu-icon-grad-green)",
				style: { mixBlendMode: "multiply" },
				transform: "translate(162)"
			})
		]
	})]
});
export default SvgLogoWaipuIcon;
